module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_general1.8230cb89da43900f0eaefbad7fefa06a.png";